import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  infoBox: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 20,
    marginRight: 10,
  },

  infoText: {
    marginLeft: 5,
  },
});
